import { render, staticRenderFns } from "./WidgetList.vue?vue&type=template&id=0939c3a5"
import script from "./WidgetList.vue?vue&type=script&lang=js"
export * from "./WidgetList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports